module.exports = __webpack_public_path__ + "static/img/pizza_slide_4.b284616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pizza_slide_4.png
// module id = mr16
// module chunks = 0